export * from "./content-section-variant-nine";
export type { CardsValue } from "./interface";
